import gql from 'graphql-tag';

export default gql`
  query getIdsByFilterLessonQuery($filter: FilterPaginationLessonInput, $sort: SortFindManyLessonInput) {
    getIdsByFilterLessonQuery(filter: $filter, sort: $sort)
  }
`;
